

TRANSLATIONS.fr.CHARGINGINFO = {
  TITLE: 'Borne de recharge',
  POWER: 'Puissance',
  EQUIPMENT: 'Équipement',
  EQUIPMENT_BASIC: 'Équipements techniques inclus :\n' +
  'contrôleur de charge, Open Charge\n'+
  'Protocol (OCPP), 1.6\n\n' +
  'Compteur électrique avec\n' +
  'protocole Modbus\n\n' +
  'Prise type 2 avec obturateur\n\n' +
  'Protection de survoltage en option',
  EQUIPMENT_ADV: 'Équipements techniques inclus :\n' +
  'contrôleur de charge, Open Charge\n'+
  'Protocol (OCPP), 1.6\n\n' +
  'Compteur électrique avec\n' +
  'protocole Modbus\n\n' +
  'Prise type 2 avec obturateur\n\n' +
  'Protection de survoltage en option\n\n' +

  'QR Code\nLecteur de carte RFID\n\n' +
  'Fonction de réservation\n\n' +
  'Anneau LED indiquant le statut de chargement',
  EQUIPMENT_PROF: 'Équipements techniques inclus :\n' +
  'contrôleur de charge, Open Charge\n'+
  'Protocol (OCPP), 1.6\n\n' +
  'Compteur électrique (eHZ EDL 21/40)\n\n' +
  'Prise type 2 avec obturateur\n\n' +
  'Protection de survoltage en option\n\n' +

  'QR Code\nLecteur de carte RFID\n\n' +
  'Fonction de réservation\n\n' +
  'Anneau LED indiquant le statut de chargement\n\n' +

  'Interrupteur de protection RCD de\n' +
  'type A avec surveillance de courant\n' +
  'résiduel continu standard et protection\n' +
  'de câble',
  EXLPANATION: 'RFID = Radio-Frequency Identification\n'+
  'QR Code = Quick Response Code',
  OK: 'OK'
};

TRANSLATIONS.fr.CHARGINGINFO.CHARGING_BASIC = TRANSLATIONS.fr.CHARGING.CHARGING_BASIC;
TRANSLATIONS.fr.CHARGINGINFO.CHARGING_ADV = TRANSLATIONS.fr.CHARGING.CHARGING_ADV;
TRANSLATIONS.fr.CHARGINGINFO.CHARGING_PROF = TRANSLATIONS.fr.CHARGING.CHARGING_PROF;

